import { render } from "./Precision.vue?vue&type=template&id=728a9c8c"
import script from "./Precision.vue?vue&type=script&lang=js"
export * from "./Precision.vue?vue&type=script&lang=js"
script.render = render

export default script